import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

@Component({
  selector: 'app-mst-region-list',
  templateUrl: './mst-region-list.component.html',
  styleUrls: ['./mst-region-list.component.scss'],
  standalone: false
})
export class MstRegionListComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  dataSource: any;
  JsonData: any[] = [];
  loading: boolean = false;
  displayedColumns: string[] = [
    "StateId",
    "Region_Name",
    "Region_Code",
    "State_Name",
    "Cluster_Count",
    "Action",
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  RegionList: any = [];
  StateListDropdown: any = [];
  SaveRegionRequestModel: RequestModel = new RequestModel();
  editRegionObj: any = {};
  selectedStateId: any = "";

    constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private LmsService: LmsService
  ) {
    this._MasterService = MasterService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
  }


  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Region List");
    this.getRegionList();
    // Fix: use GetState for state dropdown instead of GetRegionMaster
    this._MasterService.GetState().subscribe((result) => {
      this.StateListDropdown = JSON.parse(JSON.stringify(result));
    });
  }

  getRegionList() {
    this.showSpinner = true;
    this.LmsService.GetRegionMaster().subscribe((result: any) => {
      this.RegionList = JSON.parse(JSON.stringify(result));
      this.dataSource = new MatTableDataSource(this.RegionList);
      this.JsonData = result;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.showSpinner = false;
    });
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("Region_List") as HTMLTableElement;
    const worksheetName = "MASTER_REGION_LIST"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  onAddRegion() {
    this.editRegionObj = {};
    this.selectedStateId = "";
    $("#EditRegionModal").modal("show");
    $("#EditRegionModal").css("z-index", "1050");
  }

  onEditRegion(region_data: any) {
    this.editRegionObj = { ...region_data };
    this.selectedStateId = region_data.StateId;
    $("#EditRegionModal").modal("show");
    $("#EditRegionModal").css("z-index", "1050");
  }

  onSaveRegion() {
    // Fix: map all fields as per SaveRegionMasterRequest model
    this.SaveRegionRequestModel.StateId = parseInt(this.selectedStateId);
    this.SaveRegionRequestModel.RegionId = this.editRegionObj.RegionId;
    this.SaveRegionRequestModel.RegionName = this.editRegionObj.Region_Name;
    this.SaveRegionRequestModel.Region_Code = this.editRegionObj.Region_Code;
    this.SaveRegionRequestModel.LoginUserId = this.data.userId;
    // Fix: use SaveRegionMaster API instead of SaveStateMaster
    this.LmsService
      .SaveRegionMaster(this.SaveRegionRequestModel)
      .subscribe((response) => {
        const msg = response?.[0]?.MSG || "Saved successfully";
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: msg,
          ...this.configSuccess,
        });
        $("#EditRegionModal").modal("hide");
        this.onCloseModal();
        this.getRegionList();
      });
  }

  onCloseModal() {
    this.editRegionObj = {};
    this.selectedStateId = "";
    $("#EditRegionModal").modal("hide");
  }
}
